import ApiService from './api-service'

class Legal extends ApiService {
    constructor() {
        super()

        // this.get = null
        // this.post = null
        this.put = null
        this.delete = null
    }


    async clearAll() {
      return Promise.all([
        super.clear('/legal'), 
        super.clear('/legal/check'), 
        super.clear('/legal/eula'), 
        super.clear('/legal/privacy'), 
        super.clear('/legal/community'), 
        super.clear('/legal/eula/check'), 
        super.clear('/legal/privacy/check'), 
        super.clear('/legal/community/check')
      ]);
    }

    getAll(options) {
      return super.get(`legal`, options)
    }

    checkAll(options) {
      return super.get(`legal/check`, options)
    }

    getEULA(options) {
      return super.get(`legal/eula`, options)
    }

    getPrivacyPolicy(options) {
      return super.get(`legal/privacy`, options)
    }

    getCommunityRules(options) {
      return super.get(`legal/community`, options)
    }

    checkEULA(options) {
      return super.get(`legal/eula/check`, options)
    }

    checkPrivacyPolicy(options) {
      return super.get(`legal/privacy/check`, options)
    }

    checkCommunityRules(options) {
      return super.get(`legal/community/check`, options)
    }

    acknowledgeAll(options) {
      return super.post(`legal/acknowledge`, {}, options)
    }

    acknowledgeEULA(options) {
      return super.post(`legal/eula/acknowledge`, {}, options)
    }

    acknowledgePrivacyPolicy(options) {
      return super.post(`legal/privacy/acknowledge`, {}, options)
    }

    acknowledgeCommunityRules(options) {
      return super.post(`legal/community/acknowledge`, {}, options)
    }
}

const _Legal = new Legal()
export default _Legal
